




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { ReferralStatus } from '@/api/types'
import { ReferralAPI } from '@/api/backend-client'
import { namespace } from 'vuex-class'
import { escapeHtml } from '@/helpers/html'

const referrals = namespace('referrals')

@Component
export default class DeleteReferralModal extends Vue {
    @Prop({ required: true }) readonly referral!: Referral
    @Prop({ type: Boolean, default: false }) value!: boolean

    visible: boolean = false
    loading: boolean = false

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    async deleteReferral(): Promise<void> {
        this.loading = true

        const value = this.referral.clone()
        value.status = ReferralStatus.CLOSED

        try {
            await ReferralAPI.update(value.id, value)
        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })
        }

        this.loading = false

        this.$emit('on-save', true)
    }
}
